// Tiny local replacement for the `classnames` package — supports the only forms
// this codebase uses: string / falsy args and plain `{ className: boolean }` maps.
type ClassValue = string | number | false | null | undefined | Record<string, unknown>;

export const cx = (...args: ClassValue[]): string => {
  const classes: string[] = [];

  for (const arg of args) {
    if (!arg) {
      continue;
    }

    if (typeof arg === 'string' || typeof arg === 'number') {
      classes.push(String(arg));
    } else {
      for (const [key, value] of Object.entries(arg)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(' ');
};
